import { AlertTriangle } from "react-feather"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"

export function ForbiddenPage() {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleGoHome = () => {
    navigate("/dashboard")
  }

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <div className="bg-white shadow rounded-lg p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 rounded-full p-4">
            <AlertTriangle size={48} className="text-red-600" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">アクセス権限がありません</h1>

        <p className="text-gray-500 mb-6">
          このページにアクセスする権限がありません。
          <br />
          アクセス権限が必要な場合は、管理者にお問い合わせください。
        </p>

        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={handleGoBack}>
            前のページに戻る
          </Button>
          <Button onClick={handleGoHome}>ダッシュボードへ</Button>
        </div>
      </div>
    </div>
  )
}
